var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsGuy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "f_stories-news",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}svg#f_stories-news:not(.animated) .animable{opacity:0}")), /*#__PURE__*/React.createElement("g", {
    id: "f--background-complete--inject-1",
    className: "animable",
    style: {
      transformOrigin: "250px 228.23px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "250px 382.525px"
    },
    id: "eldxs3zmme9ee",
    className: "animable",
    d: "M0 382.4h500v.25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "433.34px 398.615px"
    },
    id: "elkexye0ged4p",
    className: "animable",
    d: "M416.78 398.49h33.12v.25h-33.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "311.61px 401.335px"
    },
    id: "el65x8rfk3inn",
    className: "animable",
    d: "M292 401.21h39.22v.25H292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "387.27px 389.335px"
    },
    id: "el60nx7tojsng",
    className: "animable",
    d: "M358.76 389.21h57.02v.25h-57.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "208.795px 391.015px"
    },
    id: "elyi8qm1tgdrq",
    className: "animable",
    d: "M174.48 390.89h68.63v.25h-68.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "255.175px 391.015px"
    },
    id: "el47lwk8nyban",
    className: "animable",
    d: "M252.01 390.89h6.33v.25h-6.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "161.735px 395.235px"
    },
    id: "elcyj2a3pubmi",
    className: "animable",
    d: "M98.33 395.11h126.81v.25H98.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 337.8H43.91a5.71 5.71 0 0 1-5.7-5.71V60.66a5.71 5.71 0 0 1 5.7-5.66H237a5.71 5.71 0 0 1 5.71 5.71v271.38a5.71 5.71 0 0 1-5.71 5.71zM43.91 55.2a5.46 5.46 0 0 0-5.45 5.46v271.43a5.46 5.46 0 0 0 5.45 5.46H237a5.47 5.47 0 0 0 5.46-5.46V60.66A5.47 5.47 0 0 0 237 55.2z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "140.46px 196.4px"
    },
    id: "el211v1l4pg2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31 337.8h-193.1a5.72 5.72 0 0 1-5.71-5.71V60.66a5.72 5.72 0 0 1 5.71-5.66h193.1a5.71 5.71 0 0 1 5.69 5.66v271.43a5.71 5.71 0 0 1-5.69 5.71zM260.21 55.2a5.47 5.47 0 0 0-5.46 5.46v271.43a5.47 5.47 0 0 0 5.46 5.46h193.1a5.47 5.47 0 0 0 5.46-5.46V60.66a5.47 5.47 0 0 0-5.46-5.46z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "356.75px 196.4px"
    },
    id: "elty0wvvo8ep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmla3w2v8q48"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "95.845px 323.56px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elu16ggr89a3n",
    d: "M78.33 264.72h35.03V382.4H78.33z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elerp00kgrgq"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "81.22px 323.56px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elo1mytmud6",
    d: "M78.33 264.72h5.78V382.4h-5.78z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "174.48px 283.33px"
    },
    id: "el9z2zldkdekn",
    className: "animable",
    d: "M107.97 268.61h133.02v29.44H107.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "174.48px 310.27px"
    },
    id: "el5wjlhizbw2",
    className: "animable",
    d: "M107.97 306.87h133.02v6.8H107.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "155.77px 269.83px"
    },
    id: "elaapap2n3ag",
    className: "animable",
    d: "M78.33 264.72h154.88v10.22H78.33z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkyc98dsoo48"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "250.725px 323.56px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "ellszxmrrz9dh",
    d: "M233.21 264.72h35.03V382.4h-35.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elubxnbjwdmqe"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "236.1px 323.56px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elq1cdnd5td1",
    d: "M233.21 264.72h5.78V382.4h-5.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell2v6mhenjn"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "314.2px 291.475px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "ely5ey8fwl2b",
    d: "M223.28 261.41h181.84v60.13H223.28z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elx1ren1ncrqk"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "314.195px 231.885px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elha79i4zh5lt",
    d: "M287.43 205.12h53.53v53.53h-53.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elyxvms5os0sp"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "314.195px 290.215px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "eljkkmrmyurur",
    d: "M287.43 263.45h53.53v53.53h-53.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elay5d7nu2h0n"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "314.195px 348.545px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elmvh8kfizul",
    d: "M287.43 321.78h53.53v53.53h-53.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4dxxsw8sljq"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "297.965px 231.875px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elgq7hc74v9y",
    d: "M271.2 221.35h53.53v21.05H271.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj41yijjf129"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "297.965px 290.215px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elueirwi67fo",
    d: "M271.2 279.69h53.53v21.05H271.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elc0apnugc47d"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "297.965px 348.545px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elkuruh0m69p",
    d: "M271.2 338.02h53.53v21.05H271.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5bsfc5kgwdm"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "352.42px 291.475px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elz28akv2nz4a",
    d: "M261.5 283.31h181.84v16.33H261.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3v1epzfj8ji"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "378.48px 291.475px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el7g4vt81lka",
    d: "M287.56 261.41H469.4v60.13H287.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6ie1fe936jn"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "378.485px 231.885px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el03lv16vinb94",
    d: "M351.72 205.12h53.53v53.53h-53.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj3kvztyu2xe"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "378.485px 290.215px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elrqlcnrlay8e",
    d: "M351.72 263.45h53.53v53.53h-53.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elf6eugi442ad"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "378.485px 348.545px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elzd5m99d6v5b",
    d: "M351.72 321.78h53.53v53.53h-53.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbtw631mnqou"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "362.245px 231.875px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elswufmg71gr",
    d: "M335.48 221.35h53.53v21.05h-53.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1okhryi3zmp"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "362.245px 290.215px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el6u2jhrijpgb",
    d: "M335.48 279.69h53.53v21.05h-53.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eloc4pgdi8ts"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "362.245px 348.545px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el8lv83bc2z0v",
    d: "M335.48 338.02h53.53v21.05h-53.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6zmobz9t7af"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "416.71px 291.475px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "eld5fmalhn776",
    d: "M325.79 283.31h181.84v16.33H325.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcdlehpc3yr"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 378.48,
    cy: 244.82,
    r: 13.82,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "378.48px 244.82px",
      transform: "rotate(-45deg)"
    },
    className: "animable",
    id: "el9861kcestu"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.33 303.16a13.83 13.83 0 0 1-27.65 0z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "317.505px 309.889px"
    },
    id: "ele06h6jxipfo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.33 292.82a13.83 13.83 0 1 1-27.65 0z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "317.505px 299.921px"
    },
    id: "el1dliqk9btr5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxq6mif297c"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "377.08px 352.405px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "eld8pcnwa6sf",
    d: "M355.35 329.5h43.46v45.81h-43.46z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "402.025px 352.405px"
    },
    id: "el0bkiw2ft5hh4",
    className: "animable",
    d: "M398.81 329.5h6.43v45.81h-6.43z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elog8w4rnhp6e"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "375.3px 167.07px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elmpc62pigqq",
    d: "M366.66 133.59h17.28v66.96h-17.28z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "352.815px 161.37px"
    },
    id: "eldnl1ivs0znb",
    className: "animable",
    d: "M319.81 200.56h57.35l8.66-78.38h-57.35l-8.66 78.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "347.55px 161.37px"
    },
    id: "elvsjig2b193",
    className: "animable",
    d: "M313.6 200.56h59.23l8.67-78.38h-59.24l-8.66 78.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "354.89px 161.37px"
    },
    id: "el5yuxlje9f4x",
    className: "animable",
    d: "M355.76 200.56h11.5l-13.25-78.38h-11.49l13.24 78.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "341.125px 161.37px"
    },
    id: "el1yqhy8wi698",
    className: "animable",
    d: "M345.52 200.56h4.46l-13.25-78.38h-4.46l13.25 78.38z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6juf5cfvxjj"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "138.445px 162.67px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elb2otiip5abi",
    d: "M63.11 95.17h150.67v135H63.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbewvqdzwrzd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "206.555px 162.67px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el48hq3a7m717",
    d: "M131.22 162.06h150.67v1.22H131.22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwcv6u6gb0np"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "138.44px 162.665px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elsq6xficif6q",
    d: "M80.94 97.33h115V228h-115z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj6yhn4nan9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "163.715px 212.335px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elisf70i2ojeq",
    d: "M147.52 189.67h32.39V235h-32.39z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "117.365px 196.375px"
    },
    id: "el7qusvpuedpm",
    className: "animable",
    d: "M100.01 219.04h32.38l2.33-45.33h-32.38l-2.33 45.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "182.945px 115.71px"
    },
    id: "elllxmrbg6qd",
    className: "animable",
    d: "M165.59 138.38h32.38l2.33-45.34h-32.38l-2.33 45.34z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcy3yikfj9zh"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "140.22px 142.395px",
      transform: "rotate(-177.49deg)"
    },
    className: "animable",
    id: "elyo698nrzyua",
    d: "M124.03 119.73h32.38v45.33h-32.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkhgi128ilko"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "92.2px 128.595px",
      transform: "rotate(178.34deg)"
    },
    className: "animable",
    id: "el19xh8d97f0v",
    d: "M76.01 105.93h32.38v45.33H76.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "f--Shadow--inject-1",
    className: "animable",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "f--path--inject-1",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f--Character--inject-1",
    className: "animable",
    style: {
      transformOrigin: "195.839px 276.71px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc3bd",
      transformOrigin: "160.33px 399.405px"
    },
    id: "elyl9o36ksfc9",
    className: "animable",
    d: "M154.92 408.35h7.73l3.09-17.89h-7.73l-3.09 17.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc3bd",
      transformOrigin: "116.885px 399.405px"
    },
    id: "ela4x995a4brf",
    className: "animable",
    d: "M109.49 408.35h7.73l7.06-17.89h-7.73l-7.06 17.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3 407.46h-9.42a.72.72 0 0 0-.68.52l-1.93 6.87a1.06 1.06 0 0 0 1 1.37c3-.05 5.26-.23 9.07-.23 2.35 0 7.17.25 10.42.25s3.85-3.21 2.54-3.5c-5.88-1.3-8-3.1-9.82-4.81a1.78 1.78 0 0 0-1.18-.47z",
    style: {
      fill: "#263238",
      transformOrigin: "118.085px 411.85px"
    },
    id: "el6df2nskrf7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.64 407.46h-8.43a.73.73 0 0 0-.69.52l-1.92 6.87a1.05 1.05 0 0 0 1 1.37c3-.05 7.45-.23 11.27-.23 4.48 0 8.32.25 13.57.25 3.17 0 4.23-3.21 2.92-3.5-6-1.32-10.89-1.46-15.92-4.68a3.41 3.41 0 0 0-1.8-.6z",
    style: {
      fill: "#263238",
      transformOrigin: "166.229px 411.85px"
    },
    id: "elp02ufqjwgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.24 187.09c4.08 2.56 8.37 5.14 12.6 7.59s8.53 4.83 12.83 6.89c1.07.53 2.14 1 3.21 1.48.53.24 1.06.43 1.59.65l.8.33.65.24a7.81 7.81 0 0 0 4.37.55 8.06 8.06 0 0 0 4.15-2.57 19.39 19.39 0 0 0 1.93-2.44c.3-.45.59-.92.86-1.4L206 197l5.66 1.3a20.93 20.93 0 0 1-.37 2.24c-.16.7-.34 1.4-.56 2.1a20.24 20.24 0 0 1-1.77 4.12 17.66 17.66 0 0 1-3 3.87 14.72 14.72 0 0 1-4.42 3 14.94 14.94 0 0 1-5.35 1.22 17.89 17.89 0 0 1-5.13-.51c-.38-.09-.84-.19-1.16-.3l-1-.31c-.65-.21-1.32-.41-1.95-.64-1.26-.47-2.56-.91-3.77-1.43a140.15 140.15 0 0 1-14.11-6.79c-2.27-1.24-4.51-2.51-6.71-3.85s-4.37-2.66-6.58-4.15z",
    style: {
      fill: "#ffc3bd",
      transformOrigin: "183.72px 200.979px"
    },
    id: "el2szovedonl1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.61 194.22c1.53 7.38 20.1 18 20.1 18l6.77-17.79s-5.29-3.31-13.19-8.59-15.37.28-13.68 8.38z",
    style: {
      fill: "#263238",
      transformOrigin: "163.924px 197.995px"
    },
    id: "eltqfbs3rp9ma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.85 199.85 5.37-8.43 4 9.18s-3.18 4.82-8.09 2.34z",
    style: {
      fill: "#ffc3bd",
      transformOrigin: "208.535px 197.535px"
    },
    id: "elz0wncjj70o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc3bd",
      transformOrigin: "213.96px 194.41px"
    },
    id: "elvijmyee3fdi",
    className: "animable",
    d: "m216.07 188.23 2.63 6.88-5.47 5.48-4.01-9.17 6.85-3.19z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk5fximhcpz"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "161.08px 395.08px"
    },
    className: "animable",
    id: "el4sqmvdvpk75",
    d: "m165.74 390.47-1.6 9.22h-7.72l1.59-9.22h7.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elk7b7i9mas7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "118.595px 395.08px"
    },
    className: "animable",
    id: "elonm7cw1qmip",
    d: "M116.55 390.47h7.73l-3.65 9.22h-7.72l3.64-9.22z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.57 184s10.73 22.12 5.29 66.64l-41 5.38c-.74-6.3 1-37.73-7.27-66.78a111.17 111.17 0 0 1 13.59-3.55 151.52 151.52 0 0 1 17.41-2.28 75.3 75.3 0 0 1 11.98.59z",
    style: {
      fill: "#263238",
      transformOrigin: "141.494px 219.697px"
    },
    id: "el3pslsijvbd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elh773oo9rxso"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m116.63 189.26.18-.06c4-1.12 8.61 3.1 11.07 9.26 3.59 9 7.82 20.87 7.82 20.87l-13.25 3.17a182.67 182.67 0 0 0-5.82-33.24z",
    style: {
      opacity: 0.2,
      transformOrigin: "126.165px 205.76px"
    },
    className: "animable",
    id: "elk1jdp239lo"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.51 165.73c1.51 5.5 3.35 15.7-.29 20a30.87 30.87 0 0 0 16.61 7c3.83-4.07.8-9.27.8-9.27-6.36-.69-6.53-5.38-5.76-9.91z",
    style: {
      fill: "#ffc3bd",
      transformOrigin: "139.494px 179.23px"
    },
    id: "el4cc4f5h6qdc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.42 234.42-9.19-51a13.08 13.08 0 0 0-10.56 15.19l4.55 25.28a13.09 13.09 0 0 0 15.2 10.53z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "152.442px 209.024px"
    },
    id: "elm84kkb46d2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0eo051zxulc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m162.42 234.42-9.19-51a13.08 13.08 0 0 0-10.56 15.19l4.55 25.28a13.09 13.09 0 0 0 15.2 10.53z",
    style: {
      opacity: 0.3,
      transformOrigin: "152.442px 209.024px"
    },
    className: "animable",
    id: "elfldvusgdlmt"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m197.63 284.9-6.44 1.16a7.93 7.93 0 0 1-9.32-7.39l-2.65-51a7.91 7.91 0 0 1 6.51-8.21l11.91-2.15a7.93 7.93 0 0 1 9.15 9.45L202 249.18a8 8 0 0 0-.14 2.35l2.22 24.87a7.92 7.92 0 0 1-6.45 8.5z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "193.085px 251.686px"
    },
    id: "elo40gfx53pa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela6a8zgrodub"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m197.64 217.29-11.91 2.14a7.93 7.93 0 0 0-6.51 8.21l.87 16.93q11.78-2 23.62-3.33l3.08-14.52a7.92 7.92 0 0 0-9.15-9.43z",
    style: {
      opacity: 0.2,
      transformOrigin: "193.085px 230.868px"
    },
    className: "animable",
    id: "elw9ozoo9hxgg"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      transformOrigin: "202.11px 256.435px"
    },
    id: "elfykckm62xug",
    className: "animable",
    d: "m207.48 264.86-10.83 1.94.09-18.78 10.83-1.95-.09 18.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.12 255.17c0 5.19-.76 9.53-1.64 9.68s-1.58-3.91-1.56-9.1.76-9.52 1.65-9.68 1.58 3.93 1.55 9.1z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "207.52px 255.46px"
    },
    id: "elhevlrzq3dyi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els0e2jy89e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.12 255.17c0 5.19-.76 9.53-1.64 9.68s-1.58-3.91-1.56-9.1.76-9.52 1.65-9.68 1.58 3.93 1.55 9.1z",
    style: {
      opacity: 0.2,
      transformOrigin: "207.52px 255.46px"
    },
    className: "animable",
    id: "elnwgml6miraa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.2 170.71a13.67 13.67 0 0 0-11 15.86l8.14 45.23a13.66 13.66 0 0 0 15.86 11 405.94 405.94 0 0 1 80.57-6.31l27.77.61-17.78-98.83-25.82 10.25a405.17 405.17 0 0 1-77.74 22.19z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "218.263px 190.643px"
    },
    id: "eldazhq2m1c9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el09u9wjequmza"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m234.5 151 15.36 85.41h4.06l-15.64-86.9c-1.28.56-2.52 1.04-3.78 1.49z",
    style: {
      opacity: 0.3,
      transformOrigin: "244.21px 192.96px"
    },
    className: "animable",
    id: "elzijwmuj7u7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.82 187c4.91 27.29 7 49.75 4.7 50.17s-8.17-21.37-13.08-48.66-7-49.75-4.7-50.17 8.17 21.32 13.08 48.66z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "275.63px 187.755px"
    },
    id: "el3zhfdxxxfx7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsk00tpr3yrc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.82 187c4.91 27.29 7 49.75 4.7 50.17s-8.17-21.37-13.08-48.66-7-49.75-4.7-50.17 8.17 21.32 13.08 48.66z",
    style: {
      opacity: 0.2,
      transformOrigin: "275.63px 187.755px"
    },
    className: "animable",
    id: "elq1q4a8ugnm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxjrw30m11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m135.14 168.91 6.72 4.61a18.4 18.4 0 0 0-.31 3.18c-2.41 0-5.88-2.24-6.32-4.72a8.56 8.56 0 0 1-.09-3.07z",
    style: {
      opacity: 0.2,
      transformOrigin: "138.451px 172.805px"
    },
    className: "animable",
    id: "elo92xzoeuzaj"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.81 143.28c4.06.37 10.18 11.28 6.11 15.12s-13.8-15.83-6.11-15.12z",
    style: {
      fill: "#263238",
      transformOrigin: "143.098px 151.079px"
    },
    id: "elwuy2pf2r8q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.56 158.84c2.37 7.2 3.38 11.55 8.08 14.13 7.06 3.88 15.28-2.38 15.13-10.27-.13-7.1-4-17.68-11.94-18.3a11.11 11.11 0 0 0-11.27 14.44z",
    style: {
      fill: "#ffc3bd",
      transformOrigin: "137.907px 159.266px"
    },
    id: "elalzr8a1ab58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 142.11a24.52 24.52 0 0 0-6-.47 24.55 24.55 0 0 0 3.17-3.55 20 20 0 0 1-6.17 2.83 10 10 0 0 0 .68-2.88c-1.53 1.84-4.13 3.09-6.94 4.14a16.21 16.21 0 0 0 2.73-5c-1.75 3.23-8.32 6-12.46 8.75h-.06a6.74 6.74 0 0 0-.83.58 3.36 3.36 0 0 0-.86.88 4.11 4.11 0 0 0 .7 6.13 3.91 3.91 0 0 0-1.25 4.91c-.06-1.4.27-2.93 1.28-3.55-1.7 4.92 4 9.56 9.08 10.87 3 .76 4.84-10.72 2-15.26 3.85-.49 7.14-1.45 9.11-2.81a10.16 10.16 0 0 1-4.6.39c3.7-1.46 7.68-3.52 10.82-3a13.44 13.44 0 0 0-4.72-.81 9.25 9.25 0 0 1 3.35-.69c3.37.14 5.59 3 4.73 4.92 1.29-2.07.82-5.41-3.76-6.38z",
    style: {
      fill: "#263238",
      transformOrigin: "134.29px 151.483px"
    },
    id: "elmav0m20t2dn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.34 168a6.88 6.88 0 0 0 5.18 1.69c2.53-.24 3-2.76 1.68-4.7-1.22-1.74-4-3.72-6.24-2.51a3.37 3.37 0 0 0-.62 5.52z",
    style: {
      fill: "#ffc3bd",
      transformOrigin: "128.547px 165.913px"
    },
    id: "el1mbx8klxrk2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.86 250.66s21 57.73 18.77 81.28c-2.29 24.51-16.48 66-16.48 66h-13.09s7.68-40 8.5-64.09c.89-26.23-23.15-59.4-24.62-79.61z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "160.868px 324.3px"
    },
    id: "elyshanvgdhan",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3ydaa3pxi8d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.44 270.56a5.76 5.76 0 0 0-1.52-.69c4.6 12.39 12.05 26.84 16.63 40.94.5-23.31-4.55-33.69-15.11-40.25z",
    style: {
      opacity: 0.2,
      transformOrigin: "150.252px 290.34px"
    },
    className: "animable",
    id: "elsensmknm5w"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.33 252.57s6 57.1-.09 79.21c-6.67 24.22-25.87 66.12-25.87 66.12h-14.15s12.32-39.9 16.72-63.9c4.78-26-1.63-58.61-3-77.94z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "131.595px 325.235px"
    },
    id: "el2n4688eq1j4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      transformOrigin: "119.115px 395.56px"
    },
    id: "el6ilm5b5iziq",
    className: "animable",
    d: "M126.86 398.21h-17.97l1.21-5.3h19.24l-2.48 5.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8knvzdgukt8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      transformOrigin: "119.115px 395.56px"
    },
    className: "animable",
    id: "el6ly89ytt28n",
    d: "M126.86 398.21h-17.97l1.21-5.3h19.24l-2.48 5.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      transformOrigin: "161.655px 395.56px"
    },
    id: "el9ufoydxwq2",
    className: "animable",
    d: "M170.05 398.21h-17.78l.29-5.04 18.48-.26-.99 5.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9v5nsh3zduk"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      transformOrigin: "161.655px 395.56px"
    },
    className: "animable",
    id: "elhuk5rpygd9t",
    d: "M170.05 398.21h-17.78l.29-5.04 18.48-.26-.99 5.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.27 157.33c.15.59.6 1 1 .85s.58-.71.43-1.31-.6-1-1-.85-.59.71-.43 1.31z",
    style: {
      fill: "#263238",
      transformOrigin: "138.983px 157.1px"
    },
    id: "elx9rbdsc2kum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 155.16c.16.6.6 1 1 .86s.59-.72.43-1.31-.6-1-1-.86-.54.71-.43 1.31z",
    style: {
      fill: "#263238",
      transformOrigin: "145.725px 154.935px"
    },
    id: "elav1byy4eeln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 156.15a20.48 20.48 0 0 0 4.19 4.19 3.75 3.75 0 0 1-2.73 1.45z",
    style: {
      fill: "#ed847e",
      transformOrigin: "145.095px 158.97px"
    },
    id: "eljcsgjsjfjq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12 164a5 5 0 0 1-4.69-.68.18.18 0 0 1 0-.26.18.18 0 0 1 .25 0 4.74 4.74 0 0 0 4.36.61.17.17 0 0 1 .22.12.2.2 0 0 1-.14.21z",
    style: {
      fill: "#263238",
      transformOrigin: "140.818px 163.656px"
    },
    id: "elh3osx1d9dys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.66 155.8a.45.45 0 0 1-.23 0 .35.35 0 0 1-.2-.47 3.91 3.91 0 0 1 2.49-2.37.35.35 0 0 1 .43.27.41.41 0 0 1-.29.45 3.12 3.12 0 0 0-2 1.89.42.42 0 0 1-.2.23z",
    style: {
      fill: "#263238",
      transformOrigin: "136.677px 154.382px"
    },
    id: "elofiga4w528",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.41 151.89a.36.36 0 0 1-.37-.09 2.73 2.73 0 0 0-2.4-1 .33.33 0 0 1-.4-.29.4.4 0 0 1 .31-.43 3.37 3.37 0 0 1 3 1.17.38.38 0 0 1 0 .52.29.29 0 0 1-.14.12z",
    style: {
      fill: "#263238",
      transformOrigin: "145.945px 150.981px"
    },
    id: "el339bdqj6w72",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.86 195.5c.86 3.35 1.76 6.87 2.73 10.28s1.94 6.84 3 10.2 2.24 6.68 3.49 9.9a62.88 62.88 0 0 0 4.23 9c.2.31.39.67.59.95l.31.45.15.22a4.39 4.39 0 0 0 1 .89 30.23 30.23 0 0 0 4 2.34c3 1.49 6.27 2.86 9.57 4.15 6.62 2.58 13.48 5 20.28 7.32l-1.32 5.65a187.47 187.47 0 0 1-21.76-4.48 100 100 0 0 1-10.84-3.56 37.88 37.88 0 0 1-5.64-2.76 15.08 15.08 0 0 1-3.2-2.57L131 243l-.25-.32-.51-.66c-.35-.44-.62-.87-.93-1.31a65.14 65.14 0 0 1-5.62-10.47c-1.56-3.49-2.88-7-4.11-10.57a201 201 0 0 1-6.17-21.51z",
    style: {
      fill: "#ffc3bd",
      transformOrigin: "143.81px 226.175px"
    },
    id: "ellbfq7zass6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.05 193.51c-3.8 8.86 2.38 29.07 2.38 29.07l18.5-4.75a152.73 152.73 0 0 0-4.93-21.07c-3.2-9.47-13-10.07-15.95-3.25z",
    style: {
      fill: "#263238",
      transformOrigin: "121.872px 205.76px"
    },
    id: "eld3u8vk78y7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.78 408.81a8.85 8.85 0 0 1-2-.28.18.18 0 0 1-.13-.15.2.2 0 0 1 .1-.18c.29-.18 2.87-1.71 3.7-1.27a.54.54 0 0 1 .28.52 1.17 1.17 0 0 1-.43 1 2.42 2.42 0 0 1-1.52.36zm-1.46-.54a3.77 3.77 0 0 0 2.75-.14.79.79 0 0 0 .29-.66.24.24 0 0 0-.11-.22c-.43-.25-1.89.44-2.93 1.02z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "120.692px 407.836px"
    },
    id: "elg44s525s7of",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.81 408.53h-.09a.17.17 0 0 1-.08-.16c0-.1.33-2.33 1.27-3.06a1 1 0 0 1 .79-.23.55.55 0 0 1 .56.47c.11.87-1.53 2.56-2.36 3a.13.13 0 0 1-.09-.02zm1.75-3.13a.72.72 0 0 0-.43.16 4.7 4.7 0 0 0-1.06 2.42c.83-.6 1.89-1.88 1.82-2.39 0 0 0-.15-.25-.18z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "119.952px 406.811px"
    },
    id: "ellq5imygero",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78 408.81a12.78 12.78 0 0 1-2.41-.28.16.16 0 0 1-.14-.15.19.19 0 0 1 .11-.19c.36-.18 3.55-1.76 4.46-1.23a.55.55 0 0 1 .28.48 1.09 1.09 0 0 1-.4.89 3 3 0 0 1-1.9.48zm-1.79-.54c1.69.28 3 .21 3.46-.21a.71.71 0 0 0 .26-.59.2.2 0 0 0-.1-.19c-.5-.28-2.31.38-3.61.99z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "165.655px 407.836px"
    },
    id: "elcbt12npjz5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4 408.53a.17.17 0 0 1-.1 0 .18.18 0 0 1-.07-.17 5.52 5.52 0 0 1 1.37-3 1.43 1.43 0 0 1 1-.32c.5.06.63.31.66.52.09.87-1.86 2.54-2.81 3zm2.07-3.13a1 1 0 0 0-.65.24 4.54 4.54 0 0 0-1.16 2.38c1-.57 2.32-1.88 2.26-2.41 0 0 0-.17-.34-.2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "164.746px 406.798px"
    },
    id: "elw4158j5qgxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.74 251.07 7.73-1.27-3.11 9.61s-6.74-.39-6.73-4.07z",
    style: {
      fill: "#ffc3bd",
      transformOrigin: "175.55px 254.605px"
    },
    id: "el7ufc4sy3km8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc3bd",
      transformOrigin: "182.575px 255.465px"
    },
    id: "elsxetvux3bcm",
    className: "animable",
    d: "m187.79 253.37-2.96 7.76-7.47-1.72 3.11-9.61 7.32 3.57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f--News--inject-1",
    className: "animable animator-active",
    style: {
      transformOrigin: "358.224px 167.184px",
      animation: "3s Infinite linear shake",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.33 143.53 381 101.43a6.47 6.47 0 0 0-7.93-4.57l-82 22a6.48 6.48 0 0 0-4.57 7.94l11.32 42.1a6.48 6.48 0 0 0 7.93 4.58l11.57-3.11 15.93 9.17-3.39-12.54 57.9-15.56a6.48 6.48 0 0 0 4.57-7.91z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "339.411px 138.089px"
    },
    id: "el29s24ellqo3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzbiamocc8vg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.33 143.53 381 101.43a6.47 6.47 0 0 0-7.93-4.57l-82 22a6.48 6.48 0 0 0-4.57 7.94l11.32 42.1a6.48 6.48 0 0 0 7.93 4.58l11.57-3.11 15.93 9.17-3.39-12.54 57.9-15.56a6.48 6.48 0 0 0 4.57-7.91z",
    style: {
      opacity: 0.2,
      transformOrigin: "339.411px 138.089px"
    },
    className: "animable",
    id: "el94i8ef5itht"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m425.74 231.68 4.38-28.5a4.28 4.28 0 0 0-3.58-4.88L371 189.76a4.27 4.27 0 0 0-4.88 3.58l-4.39 28.5a4.28 4.28 0 0 0 3.58 4.88l7.83 1.21 7.19 9.8 1.31-8.5 39.18 6a4.28 4.28 0 0 0 4.92-3.55z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "395.925px 213.719px"
    },
    id: "elplb7dprm08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxpnzdjupuz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m425.74 231.68 4.38-28.5a4.28 4.28 0 0 0-3.58-4.88L371 189.76a4.27 4.27 0 0 0-4.88 3.58l-4.39 28.5a4.28 4.28 0 0 0 3.58 4.88l7.83 1.21 7.19 9.8 1.31-8.5 39.18 6a4.28 4.28 0 0 0 4.92-3.55z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "395.925px 213.719px"
    },
    className: "animable",
    id: "elobl8sfjakin"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m423.77 185.48-7.14-51a7.66 7.66 0 0 0-8.65-6.52l-99.41 13.9a7.66 7.66 0 0 0-6.52 8.65l7.14 51a7.64 7.64 0 0 0 8.64 6.52l14-2 17.35 13.09-2.13-15.22 70.17-9.81a7.67 7.67 0 0 0 6.55-8.61z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "362.906px 173.503px"
    },
    id: "elc0g44s5n1d5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.43 164.26 5.63-.79 8.85 9.76-1.51-10.79 5.68-.79 2.73 19.5-5.68.8-8.8-9.69 1.5 10.71-5.67.79z",
    style: {
      fill: "#fff",
      transformOrigin: "329.12px 172.705px"
    },
    id: "ele6aw3i0vrkv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.07 161.09 16.16-2.26.58 4.17-10.11 1.41.43 3.1 9.38-1.31.56 4-9.38 1.31.53 3.84 10.41-1.45.62 4.41-16.45 2.3z",
    style: {
      fill: "#fff",
      transformOrigin: "350.66px 169.72px"
    },
    id: "elypcn61nkrlp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.76 158.62 5.72-.8 3.59 10.63 1.49-11.34 5.7-.8 4.55 10.48.54-11.19 5.69-.8-1.57 20.11-5.91.82-5.14-11.8-1.69 12.76-5.91.82z",
    style: {
      fill: "#fff",
      transformOrigin: "372.4px 166.155px"
    },
    id: "el02hdqrrmzgb7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.78 167.72 5.69-1.16a4.4 4.4 0 0 0 1 2 3.25 3.25 0 0 0 2.83.81 2.94 2.94 0 0 0 1.9-.89 1.84 1.84 0 0 0 .51-1.5 1.82 1.82 0 0 0-.86-1.26 7.74 7.74 0 0 0-3.24-.7 13.3 13.3 0 0 1-6-1.58 4.82 4.82 0 0 1-2.23-3.52 5.16 5.16 0 0 1 .48-3 5.87 5.87 0 0 1 2.32-2.47 12.39 12.39 0 0 1 4.69-1.43 10 10 0 0 1 5.9.59 6.06 6.06 0 0 1 2.95 4.1l-5.63 1.13a3.11 3.11 0 0 0-1.22-1.79 3.16 3.16 0 0 0-2.09-.32 2.42 2.42 0 0 0-1.52.67 1.39 1.39 0 0 0-.38 1.16 1.1 1.1 0 0 0 .56.78 5.05 5.05 0 0 0 2.12.43 25.69 25.69 0 0 1 5.9.93 6.07 6.07 0 0 1 2.79 1.82 5.53 5.53 0 0 1 1.18 2.78 6.22 6.22 0 0 1-.55 3.6 6.58 6.58 0 0 1-2.56 2.81 11.81 11.81 0 0 1-4.59 1.47q-5 .7-7.16-1a7.69 7.69 0 0 1-2.79-4.46z",
    style: {
      fill: "#fff",
      transformOrigin: "397.413px 163.101px"
    },
    id: "elp8nlnu89hgq",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsGuy);
export default __webpack_public_path__ + "static/media/news-guy.248d225de383ff5d282d61829d88c730.svg";
export { ForwardRef as ReactComponent };